import { use } from 'react';
import { useHits } from 'react-instantsearch';
import { BuyerListingFavorite } from '@/legacy/favorites/FavoritesViewModel';
import { ListingHit } from '@/types/ListingHit';
import { ListingCardHits } from './ListingCardHits';

type Props = {
  favoritesPromise: Promise<BuyerListingFavorite[]>;
  isStockXSectionEnabled: boolean;
};

export const AllInventoryHits = ({ favoritesPromise, isStockXSectionEnabled }: Props) => {
  const favorites = use(favoritesPromise);
  const { items } = useHits<ListingHit>();

  return (
    <ListingCardHits
      items={items}
      favorites={favorites}
      section="All Inventory"
      isStockXSectionEnabled={isStockXSectionEnabled}
    />
  );
};
